import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Modal, CloseButton, Button } from '@spotahome/ui-library';

import Metrics from '@spotahome/soyuz-metrics';
import { trans } from '@spotahome/soyuz/client';

import OtherCityImage from './icons/OtherCityImage';

import './OtherCityModal.scss';

const OtherCityModal = ({ isOpen, handleModalClose }) => {
  const [desiredCity, setDesiredCity] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleOnClose = () => {
    handleModalClose();
  };

  useEffect(() => {
    setDesiredCity('');
    setSubmitted(false);
  }, [isOpen]);

  const handleInputChange = e => {
    setDesiredCity(e.target.value);
  };

  const handleOnFeedbackSubmit = () => {
    Metrics.ga.sendEvent('Home', 'other-city', desiredCity);
    setSubmitted(true);
  };

  const titleKey = submitted
    ? 'landingpage.city-selector.other.modal.thankyou'
    : 'landingpage.city-selector.other.modal.title';

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleOnClose}
        className="other-city-modal"
      >
        <CloseButton
          size="small"
          onClick={handleOnClose}
          className="other-city-close"
        />
        <OtherCityImage className="other-city-image" />
        <h1 className="other-city-title">{trans(titleKey)}</h1>
        {submitted ? (
          <Fragment>
            <p
              className="other-city-comingsoon"
              data-test="otherCityComingSoon"
            >
              {trans('landingpage.city-selector.other.modal.p1')}
            </p>
            <p className="other-city-comingsoon">
              {trans('landingpage.city-selector.other.modal.p2')}
            </p>
          </Fragment>
        ) : (
          <Fragment>
            <input
              data-test="otherCityTextInput"
              className="other-city-input"
              type="text"
              onChange={handleInputChange}
              value={desiredCity}
              placeholder={trans(
                'landingpage.city-selector.other.modal.placeholder'
              )}
            />
            <Button
              data-test="otherCitySendBtn"
              className="other-city-button"
              disabled={!desiredCity}
              onClick={handleOnFeedbackSubmit}
            >
              {trans('landingpage.city-selector.other.modal.send')}
            </Button>
          </Fragment>
        )}
      </Modal>
    </Fragment>
  );
};

OtherCityModal.propTypes = {
  handleModalClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default OtherCityModal;
